import { render, staticRenderFns } from "./multitasking-a45.vue?vue&type=template&id=b8c8bb08&"
import script from "./multitasking-a45.vue?vue&type=script&lang=js&"
export * from "./multitasking-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports